export const UPDATE_SELECT_ROW_PHONE = 'UPDATE_SELECT_ROW_PHONE'
export const UPDATE_BACKLIST_DETAIL = 'UPDATE_BACKLIST_DETAIL'
export const UPDATE_COLUMN_FILE = 'UPDATE_COLUMN_FILE'
export const UPDATE_LOADING_CREATE_BACKLIST = 'UPDATE_LOADING_CREATE_BACKLIST'
export const UPDATE_COLUMN_FILE_BACKLIST = 'UPDATE_COLUMN_FILE_BACKLIST'
export const UPDATE_FILE_BACKLIST_IMPORT = 'UPDATE_FILE_BACKLIST_IMPORT'
export const UPDATE_STEP_IMPORT_FILE_BACKLIST = 'UPDATE_STEP_IMPORT_FILE_BACKLIST'
export const UPDATE_BLACKLIST_PAGINATION = 'UPDATE_BLACKLIST_PAGINATION'
export const UPDATE_IMPORT_DATA = 'UPDATE_IMPORT_DATA'